import React, { useState } from "react";
import { Layout, Input, Button, message, Image } from "antd";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import colors from "../assets/styles/colour";
import logo from "../assets/images/bjp final.png";
import authService from "../networks/api/service/authService";

const { Content } = Layout;
const email = localStorage.getItem("email");
console.log(email);
const ResetPassword = () => {const [username, setUsername] = useState("");
  const [newPassword, setnewPassword] = useState("");
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const token = location.state?.token; // Retrieve token from login redirection

  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async () => {
    if (!password || !confirmPassword) {
      message.warning("Please enter a new password.");
      return;
    }

    const username = localStorage.getItem("username");
    if (password.length < 8) {
      message.error("Password must be at least 8 characters long.");
      return;
    }

    // if (!/^[A-Z]/.test(password.trim())) {
    //   message.error("Password must start with a capital letter.");
    //   return;
    // }

    if (password !== confirmPassword) {
      message.error("Passwords do not match.");
      return;
    }

    const payload = {
      email: email,
      newPassword: password,
      confirmPassword: confirmPassword,
    };

    setLoading(true);
    console.log("Reset Password Payload:", payload);
  try {
  const response = await authService.resetPassword(payload);
  console.log("Reset Password Response:", response);

  if (response.code === 200) {
    message.success("Password reset successful! Please log in.");

    localStorage.removeItem("token");
    localStorage.removeItem("username");

    setPassword("");
    setConfirmPassword("");

    navigate("/signin", { replace: true });
  } else {
    message.error(response.message || "Failed to reset password. Try again.");
  }
} catch (error) {
  console.error("Reset Password Error:", error);
  message.error("An error occurred. Please try again.");
} finally {
  setLoading(false);
} 
    
  };
  
  return (
    <Layout className="login-layout">
  
    <div className="login-right" style={{  display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%", }}>
  <div
    className="login-box"
    style={{
      width: "100%",
      maxWidth: "620px",
      padding: "30px",
      backgroundColor: "#ffffff",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      borderRadius: "12px",
    }}
  >
    <div
      className="login-logo"
      style={{ textAlign: "center", marginBottom: "20px" }}
    >
      <Image
        src={logo}
        alt="Logo"
        preview={false}
        style={{
          height: "100px",
          width: "auto",
          objectFit: "contain",
        }}
      />
    </div>
    <h2
      className="login-title"
      style={{
        textAlign: "center",
        color: "#0b023d",
        fontSize: "24px",
        fontWeight: "600",
        marginBottom: "25px",
      }}
    >
      Reset Password
    </h2>

    <Input.Password
      placeholder="New Password"
      className="login-input"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      style={{
        marginBottom: "15px",
        padding: "10px",
        borderRadius: "8px",
      }}
    />
    <Input.Password
      placeholder="Confirm New Password"
      className="login-input"
      value={confirmPassword}
      onChange={(e) => setConfirmPassword(e.target.value)}
      style={{
        marginBottom: "20px",
        padding: "10px",
        borderRadius: "8px",
      }}
    />
    <Button
      type="primary"
   
      style={{
        backgroundColor: colors.button,
        color: colors.sidebarText,
        border: `1px solid ${colors.sidebarText}`,
        width: "100%",
        height: "50px",
        padding: "10px 0",
        fontWeight: "bold",
        borderRadius: "8px",
        transition: "all 0.3s",
      }}
      loading={loading}
      onClick={handleResetPassword}
    >
      Reset Password
    </Button>
    <div
      style={{
        marginTop: "20px",
        textAlign: "right",
      }}
    >
      <Link to="/login/dashboard" style={{ color: "#0b023d", fontWeight: "500" }}>
        TRY IT LATER
      </Link>
    </div>
  </div>
</div>

    
    </Layout>
  );
};

export default ResetPassword;
